import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MarkupsService, PlatformMarkup } from '@app/features/pricing-and-availability/';
import { isNullOrUndefined } from '@app/shared/utils';

@Component({
  standalone: false,
  selector: 'sbnb-connect-set-markup',
  templateUrl: './connect-booking-set-markup.component.html',
  styleUrls: ['./connect-booking-set-markup.component.scss'],
})
export class ConnectSetMarkupComponent implements OnInit {
  @Input() platform: 'agoda' | 'homeaway' | 'booking';
  @Output() stepComplete: EventEmitter<boolean> = new EventEmitter();

  saving: boolean;

  constructor(
    private readonly markupsService: MarkupsService,
    private readonly router: Router
  ) {}

  markup: number;
  placeholder_markup: string;
  default_markup = '18';
  bookingcom_markup = 17.5;

  ngOnInit(): void {
    // Check to see if there is a existing value set for platform markup
    this.markupsService.getPlatformMarkups().subscribe((res) => {
      const platform = res.find((x) => x.platform === this.platform);

      if (!isNullOrUndefined(platform.markup)) {
        this.placeholder_markup = (platform.markup * 100).toString();

        if (this.platform === 'booking') {
          this.markup = platform.markup * 100;
        }
      } else {
        this.placeholder_markup = this.default_markup;

        if (this.platform === 'booking') {
          this.placeholder_markup = this.bookingcom_markup.toString();
          this.markup = this.bookingcom_markup;
        }
      }
    });
  }

  skip() {
    this.stepComplete.emit(true);
  }

  progress() {
    if (!this.markup) {
      return;
    }

    this.saving = true;

    const payload: PlatformMarkup[] = [
      {
        platform: this.platform,
        markup: this.markup / 100,
      },
    ];

    this.markupsService.updatePlatformMarkups(payload).subscribe(
      (res) => {
        this.saving = false;
        if (res?.error) {
          return;
        }

        this.stepComplete.emit(true);
      },
      (err) => {
        this.saving = false;
      }
    );
  }
}
